import { memo } from 'react'

// import { LOCALE } from '@hhgtech/hhg-components/types'

// import { useIsMobile } from 'hooks/useIsMobile'
// import { useRouterExtend } from 'hooks/useRouterExtend'
// import { setGlobalTargeting } from 'utils/ads'

export const OutOfPageAd = memo((_props: any) => {
  return null
})

// export const OutOfPageAd = memo(
//   ({
//     adUnitPath,
//     id,
//     customTargetings,
//     className,
//   }: {
//     adUnitPath: string
//     id: string
//     customTargetings?: {
//       [key: string]: (string | number) | (string | number)[]
//     }
//     className?: string
//   }) => {
//     const isMobile = useIsMobile()
//     const [isInit, setIsInit] = useState(false)
//     const displayRef = useRef(false)
//     const adSlotRef = useRef<any>()
//     const { locale } = useRouterExtend()
//     useEffect(() => {
//       window.googletag = window.googletag || { cmd: [] }
//       const { googletag } = window
//       googletag.cmd.push(function () {
//         const slot = googletag.defineOutOfPageSlot(adUnitPath, id)
//         adSlotRef.current = slot
//         if (slot) {
//           setGlobalTargeting(slot)
//           slot.setTargeting('Pos', ['OOP'])
//           if (customTargetings) {
//             Object.keys(customTargetings).forEach((k) => {
//               if (k) slot.setTargeting(k, customTargetings[k])
//             })
//           }
//           slot.addService(googletag.pubads())
//           if (locale !== LOCALE.Vietnam) {
//             googletag.pubads().enableSingleRequest()
//           }
//           googletag.enableServices()
//         }
//       })
//       setIsInit(true)
//     }, [])
//     // set targeting base on customTargetings changes
//     useEffect(() => {
//       if (isInit && adSlotRef.current) {
//         const { googletag } = window
//         googletag.cmd.push(function () {
//           if (customTargetings) {
//             Object.keys(customTargetings).forEach((k) => {
//               if (k) adSlotRef.current?.setTargeting(k, customTargetings[k])
//             })
//           }
//         })
//       }
//     }, [isInit, JSON.stringify(customTargetings)])
//     useEffect(() => {
//       if (!displayRef.current && isInit && isMobile) {
//         displayRef.current = true
//         window.googletag = window.googletag || { cmd: [] }
//         const { googletag } = window
//         googletag.cmd.push(function () {
//           googletag.display(id)
//           if (adSlotRef.current && googletag.pubads().isInitialLoadDisabled()) {
//             googletag.pubads().refresh([adSlotRef.current])
//           }
//         })
//       }
//     }, [isInit, isMobile])
//     return (
//       <div>
//         <div className={className} id={id}></div>
//       </div>
//     )
//   },
// )
